import { SingleValueProps } from "react-select";
import "./TwoRowSelectSingleValue.scss";

export const TwoRowSelectSingleValue = ({
  innerProps,
  data,
}: SingleValueProps<any, any>) => {
  return (
    <div className="two-row-select-single-value" {...innerProps}>
      {data.name}
    </div>
  );
};
